import Link, { type LinkProps } from '@carvana/ds-link';
import React from 'react';

type OwnProps = React.PropsWithChildren<{
  className?: string;
  'data-testid'?: string;
  section: string;
  size?: LinkProps['size'];
  url: string;
}>;

export default function ExternalLink({
  children,
  className = 'text-current',
  section,
  size,
  url,
  ...rest
}: OwnProps) {
  return (
    <Link
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      size={size}
      className={className}
      preventVisitedColor
      data-analytics-id="External Site"
      data-analytics-attributes={JSON.stringify({ location: section, url })}
      data-testid={rest['data-testid'] || 'external-link'}
      testId={rest['data-testid'] || 'external-link'}
      {...rest}
    >
      {children}
    </Link>
  );
}
